import { render } from "./SeccionProdsDestacar.vue?vue&type=template&id=22d1f3fa&scoped=true"
import script from "./SeccionProdsDestacar.vue?vue&type=script&lang=js"
export * from "./SeccionProdsDestacar.vue?vue&type=script&lang=js"

import "./SeccionProdsDestacar.vue?vue&type=style&index=0&id=22d1f3fa&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d1f3fa"]])

export default __exports__